import request from '@/utils/request'

// 新增合同管理
export function addContract(data) {
  return request({
    url: '/cont/put/contract',
    method: 'post',
    data: data
  })
}

// 修改合同管理
export function updateContract(data) {
  return request({
    url: '/cont/put/contract',
    method: 'put',
    data: data
  })
}

// 删除合同管理
export function delContract(contractId) {
  return request({
    url: '/cont/put/contract/' + contractId,
    method: 'delete'
  })
}

// 导出合同管理
export function exportContract(query) {
  return request({
    url: '/cont/put/contract/export',
    method: 'get',
    params: query
  })
}

// 查询【未上传合同】列表
export function listOrder(query) {
  return request({
    url: '/cont/put/contract/list',
    method: 'get',
    params: query
  })
}

// 查询【未上传合同】详细
export function getPutOrder(custOrderId) {
  return request({
    url: '/cont/put/contract/' + custOrderId,
    method: 'get'
  })
}


